import NotificationListPage from "@/components/notifications/NotificationListPage"

const SupermarketNotification = () => (
    <NotificationListPage title="Thông báo" scope="mine" />
)

export default SupermarketNotification
